import React from 'react';
import {breaklinesUnsafe} from '../../../../../../../utils/textMixin';

const CancellationPolicies = ({policies}) => {
    return (
        <div className="CancelSection__section-content">
            <ul className="policy-list" data-testid="policy-ul">
                {policies.map((policy, index) => {
                    /* eslint-disable react/no-danger */
                    return (
                        <li
                            key={index}
                            data-testid="policy-item"
                            className="policy-list-item"
                            dangerouslySetInnerHTML={{
                                __html: breaklinesUnsafe(policy.label),
                            }}
                        />
                    );
                })}
            </ul>
        </div>
    );
};

export default CancellationPolicies;
